function getUnit(content, pathName) {
  if (pathName === "/home" || pathName === "/" || pathName === "curator") {
    return null;
  }
  let unitreturn = null;
  content.forEach(cat => {
    cat.units.forEach( unit => {
        let aliases = unit.path_alias.split(',');
        let isAlias = aliases.includes(pathName);
        if( unit.path ===  pathName || isAlias) {
            unitreturn = unit;
        }
    })
  });
  return unitreturn;
}

const unitHelper = { getUnit };

export default unitHelper;
